import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-questionaire-dropdown',
  templateUrl: './questionaire-dropdown.component.html',
  styleUrl: './questionaire-dropdown.component.sass'
})
export class QuestionaireDropdownComponent implements OnInit {

  @Input()
  type: string;
  @Input()
  start: any;
  @Input()
  end: any;
  range: any[];
  selected: any;

  @Output()
  valSelected = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
    this.range = [];
    if (this.type == 'ageRange') {
      this.selected = this.start;
      this.genAgeRange();
    }
  }

  valueSelected(e) {
    this.valSelected.emit(this.selected);
  }

  genAgeRange() {
    let age = this.start;
    this.range.push(age);
    for (var i = 0; i < this.end; i++) {
      age = age + 1;
      this.range.push(age);
    }
  }
}
